import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { uuidv4 } from "../../../helpers/utility";

const minuteSeconds = 60;
const hourSeconds = 3600;
const daySeconds = 86400;

const timerProps = {
    isPlaying: true,
    size: 100,
    strokeWidth: 6
};

const renderTime = (dimension, time) => {
    return (
        <div className="time-wrapper">
            <div className="time">{time}</div>
            <div>{dimension}</div>
        </div>
    );
};

const getTimeSeconds = (time) => (minuteSeconds - time) | 0;
const getTimeMinutes = (time) => ((time % hourSeconds) / minuteSeconds) | 0;
const getTimeHours = (time) => ((time % daySeconds) / hourSeconds) | 0;
const getTimeDays = (time) => (time / daySeconds) | 0;

export default function TimerView(props) {
    const { endTime, timerInfo } = props;
    const [remainingTime, setRemainingTime] = useState(0);
    const [daysDuration, setDaysDuration] = useState(0);
    const [key, setKey] = useState("23432");

    useEffect(() => {
        const stratTime = Date.now() / 1000;
        setRemainingTime(endTime - stratTime);
        const days = Math.ceil(remainingTime / daySeconds);
        setDaysDuration(days * daySeconds);
        setKey(uuidv4());
    }, [timerInfo])

    return (
        <div className="flex justify-between" key={key + "Test"}>
            <CountdownCircleTimer
                key={key + "1"}
                {...timerProps}
                colors="#7E2E84"
                duration={daysDuration}
                initialRemainingTime={remainingTime}
            >
                {({ elapsedTime, color }) => (
                    <span style={{ color }}>
                        {renderTime("days", getTimeDays(daysDuration - elapsedTime))}
                    </span>
                )}
            </CountdownCircleTimer>
            <CountdownCircleTimer
                {...timerProps}
                key={key + '2'}
                colors="#D14081"
                duration={daySeconds}
                initialRemainingTime={remainingTime % daySeconds}
                onComplete={(totalElapsedTime) => {
                    return ({
                        shouldRepeat: remainingTime - totalElapsedTime > hourSeconds
                    })
                }}
            >
                {({ elapsedTime, color }) => (
                    <span style={{ color }}>
                        {renderTime("hours", getTimeHours(daySeconds - elapsedTime))}
                    </span>
                )}
            </CountdownCircleTimer>
            <CountdownCircleTimer
                {...timerProps}
                key={key + '3'}
                colors="#EF798A"
                duration={hourSeconds}
                initialRemainingTime={remainingTime % hourSeconds}
                onComplete={(totalElapsedTime) => ({
                    shouldRepeat: remainingTime - totalElapsedTime > minuteSeconds
                })}
            >
                {({ elapsedTime, color }) => (
                    <span style={{ color }}>
                        {renderTime("minutes", getTimeMinutes(hourSeconds - elapsedTime))}
                    </span>
                )}
            </CountdownCircleTimer>
            <CountdownCircleTimer
                {...timerProps}
                colors="#218380"
                key={key + '4'}
                duration={minuteSeconds}
                initialRemainingTime={remainingTime % minuteSeconds}
                onComplete={(totalElapsedTime) => {
                    if (!(remainingTime - totalElapsedTime > hourSeconds)) {
                        props.onComplete()
                    }
                    return ({
                        shouldRepeat: remainingTime - totalElapsedTime > hourSeconds
                    })
                }}
            >
                {({ elapsedTime, color }) => (
                    <span style={{ color }}>
                        {renderTime("seconds", getTimeSeconds(elapsedTime))}
                    </span>
                )}
            </CountdownCircleTimer>
        </div>
    );
}
